/**
 * Renders in the theme that André designed,
 * but with a more modern twist.
 * TODO Implement.
 *
 * @type {import("../useFormTheme").FormTheme}
 */
var modern = {
  form: {
    backgroundColor: 'white',
    border: 1,
    borderColor: 'border',
    paddingX: 3,
    paddingY: 4
  },
  fieldLayout: {
    backgroundColor: 'nuanced',
    borderTopLeftRadius: 'large',
    borderTopRightRadius: 'large',
    marginBottom: 2,
    padding: 2,
    marginRight: 'auto',
    width: 'auto'
  },
  label: {},
  field: {},
  input: {
    backgroundColor: 'transparent',
    border: 0,
    borderBottom: 1,
    borderColor: 'border',
    boxShadow: 'none',
    ':focus': {
      outline: 'none',
      borderColor: 'primary',
      boxShadow: function boxShadow(theme) {
        return "0 1px ".concat(theme.colors.primary);
      }
    }
  },
  textArea: {},
  checkbox: {},
  radio: {},
  description: {},
  warning: {},
  error: {}
};
export default modern;